import { render, staticRenderFns } from "./WebinarView.vue?vue&type=template&id=24340052&scoped=true"
import script from "./WebinarView.vue?vue&type=script&lang=js"
export * from "./WebinarView.vue?vue&type=script&lang=js"
import style0 from "./WebinarView.vue?vue&type=style&index=0&id=24340052&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24340052",
  null
  
)

export default component.exports